import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { catchError, throwError } from 'rxjs';
import { AuthService, FormService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { dateRangeValidator } from './forms-validator/date-range';

@Component({
	selector: 'app-open-form',
	templateUrl: './open-form2.component.html',
	styleUrls: ['./open-form2.component.scss'],
})
export class OpenForm2Component implements OnInit {
	@Input() form: any = [];
	@Input() onSubmitForm: any;
	@Input() values: any = {};
	@Input() defaultData: any = {};
	@Input() formTitle: string = '';
	@Input() selectOptions: any = { name: null, id: null };
	@Input() isUpdate = false;
	@Input() ref: any;
	@Input() multiValueSelect: any = false;
	public isLoading = false;
	options: any = [];
	totalOptions: any;
	searchItem: any = 'a';
	editForm: any = this.formBuilder.group({});
	showImgPreview = false;

	constructor(
		public popoverController: PopoverController,
		public formService: FormService,
		private authService: AuthService,
		public formBuilder: FormBuilder,
		private http: HttpClient,
	) {}

	public ngOnInit(): void {
		if (this.defaultData.id) {
			this.options.push(this.defaultData);
		}

		this.fetchOption(0, 10).subscribe((data: any) => {
			if (data) {
				this.options = data.data;
				this.totalOptions = data.totalCount;
			}
		});

		for (let i = 0; i < this.form.length; i++) {
			const validations = [];

			if (this.form[i].required) {
				validations.push(Validators.required);
			}
			if (this.form[i].maxLength) {
				validations.push(Validators.maxLength(this.form[i].maxLength));
			}
			if (this.form[i].minLength) {
				validations.push(Validators.minLength(this.form[i].minLength));
			}

			if (this.form[i].type === 'url' || this.form[i].type === 'image') {
				validations.push(
					Validators.pattern(
						'(?:(?:(?:ht|f)tp)s?://)?[\\w_-]+(?:\\.[\\w_-]+)+([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?',
					),
				);
			}
			if (this.form[i].type === 'email') {
				validations.push(
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
				);
			}
			if (this.form[i].type === 'number') {
				validations.push(Validators.pattern('^[0-9]*$'));
			}

			if (this.form[i].type === 'datetime-local') {
				this.editForm.addControl(
					this.form[i].formControlName,
					new FormControl(new Date(), validations),
				);
			} else {
				this.editForm.addControl(
					this.form[i].formControlName,
					new FormControl(null, validations),
				);
			}

			if (this.form[i].dateRangeValidator) {
				this.editForm.addValidators(
					dateRangeValidator(
						this.form[i].dateRangeValidator,
						this.form[i].formControlName,
					),
				);
			}
		}

		this.editForm.patchValue(this.values);
	}

	public close() {
		this.popoverController.dismiss();
	}

	public onSubmit(editForm: any) {
		if (!this.isLoading) {
			this.isLoading = true;

			this.formService.markFormGroupTouched(editForm);

			if (editForm.status !== 'VALID') {
				this.isLoading = false;

				this.authService.addToastMsg('Please fill missing detail.');
				return;
			}

			this.onSubmitForm(this.ref, editForm.value)
				.pipe(
					catchError((errors: HttpErrorResponse) => {
						this.isLoading = false;
						return throwError('errorMsg');
					}),
				)
				.subscribe((data: any) => {
					this.isLoading = false;
					this.reloadProfile();
				});
		}
	}
	public reloadProfile() {
		this.close();
	}

	imageUpload(url: any, formControlName: any) {
		console.log(url, 'amazon img url', formControlName, 'formControlName');
		this.showImgPreview = true;
		const formObj: any = {};
		formObj[formControlName] = url;
		this.editForm.patchValue(formObj);
	}

	deleteImage(path: any, url: any, formControlName: any) {
		console.log(url, 'amazon img url', formControlName, 'formControlName');
		const formObj: any = {};
		formObj[formControlName] = null;

		this.deleteUploadFile(path, url).subscribe(() => {
			this.editForm.patchValue(formObj);
			this.showImgPreview = false;
		});
	}

	onClear(e: any) {
		this.fetchOption(0, 10).subscribe((data: any) => {
			if (data) {
				this.options = data.data;
				this.searchItem = 'a';
				this.totalOptions = data.totalCount;
			}
		});
	}

	onScroll(e: any) {
		let page;
		if (this.options.length > 10) {
			page = Math.floor(this.options.length / 10);
		} else {
			page = 1;
		}
		this.fetchOption(
			page,
			10,
			this.searchItem === '' ? 'a' : this.searchItem,
		).subscribe((data: any) => {
			if (data) {
				this.options = [...this.options, ...data.data];
			}
		});

		// }
	}
	searchCompany(e: any) {
		this.searchItem = e.term;
		this.options = [];
		this.fetchOption(0, 10, e.term).subscribe((data: any) => {
			if (data) {
				this.options = data.data;
				this.totalOptions = data.totalCount;
			}
		});
	}

	fetchOption(pageNum: number, limit: number, search = 'a') {
		return this.http.get(
			environment.url.company +
				`/company/page/${pageNum}/limit/${limit}/search/${search}/v2`,
		);
	}

	deleteUploadFile(path: number, url: string) {
		return this.http.delete<any>(
			`${environment.url.profile}/remove/${path}/${
				url.split('/')[url.split('/').length - 1]
			}`,
		);
	}
	hideImgPreview(event: any) {
		this.showImgPreview = false;
	}

	copyUrl(url: string) {
		navigator.clipboard
			.writeText(url)
			.then(() => {
				this.authService.addToastMsg('Event Link Copied');
			})
			.catch(error => {
				this.authService.addToastMsg('Could Not Copy Event Link');
			});
	}
}
